import { render, staticRenderFns } from "./Triptychs.vue?vue&type=template&id=9187b7a6&scoped=true&"
import script from "./Triptychs.vue?vue&type=script&lang=js&"
export * from "./Triptychs.vue?vue&type=script&lang=js&"
import style0 from "./Triptychs.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Triptychs.vue?vue&type=style&index=1&id=9187b7a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9187b7a6",
  null
  
)

export default component.exports